import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  // Any mutation (create / adjust / renew / suspend / release / delete /
  // settings / channel / route…) refetches all active queries once it settles,
  // so the UI always reflects the latest server state without each call having
  // to hand-wire invalidation. Active queries refetch immediately; unmounted
  // ones are marked stale and refetch when next shown. No loop: invalidation
  // triggers query refetches, not mutations. Errors surface a toast app-wide.
  mutationCache: new MutationCache({
    onError: (err) => {
      const msg = err instanceof ApiError ? err.message : err instanceof Error ? err.message : String(err);
      toast.error(msg || '操作失败');
    },
    onSettled: () => {
      queryClient.invalidateQueries();
    },
  }),
  defaultOptions: {
    queries: {
      retry: (failureCount, err) => {
        if (err instanceof ApiError && (err.status === 401 || err.status === 404)) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
